let $ = require('jquery')
let Vue = require('vue')

Vue.directive('slimscroll', {
    twoWay: true,
    priority: 1000,
    params: ['height', 'always'],
    paramWatchers: {
        height () {
            $(this.el).slimScroll({ destroy: true }).slimScroll({
                height: this.params.height,
                alwaysVisible: this.params.always || false,
                size: '10px'
            })
        }
    },
    bind () {
        $(this.el).slimScroll({
            height: this.params.height,
            alwaysVisible: this.params.always || false,
            size: '10px'
        })
    }
})



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/slimscroll.js